import { useEffect } from "react";
import { postApi } from "../api/Setters/post.api.js";

const POLL_INTERVAL_MS = 1000;

function start() {
  let intervalId;

  intervalId = setInterval(() => {
    postApi("users/active/update_latest_timestamp")
  }, POLL_INTERVAL_MS);

  return intervalId;
}

export default function useUserActive(isLoggedIn) {
  useEffect(() => {
    let intervalId;

    if (isLoggedIn) {
      intervalId = start();
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isLoggedIn])
}
